import { GenIcon } from '../helpers/IconBase.es.js';

const FireFlashsaleColored = (props) => {
  return GenIcon({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          d: "M11.8903 0.644C10.0379 1.936 8.46667 3.909 7.58667 6.007C6.99487 5.972 6.4 6.085 5.85128 6.349C3.84308 7.297 2.12923 9.737 2.00923 13.781C2.00205 13.871 2 14.01 2 14.249C2 19.628 6.48308 23.999 12 23.999C17.5292 23.984 22 19.621 22 14.249C22 14.108 21.9928 13.956 21.9815 13.755C21.9774 13.695 21.9774 13.695 21.9744 13.637C21.9662 13.509 21.9579 13.394 21.9518 13.309C21.7426 10.656 20.8462 8.735 19.1744 6.488C19.0472 6.316 18.9477 6.185 18.7292 5.898C18.3662 5.422 18.2174 5.223 18.0554 4.991C17.5467 4.264 17.3846 3.856 17.3846 3.376C17.3846 2.111 16.6595 0.955 15.5097 0.376C15.0103 0.124 14.4667 0 13.9231 0C13.2072 0 12.4944 0.216 11.8903 0.644Z",
          fill: "white"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M13.6997 3.07C12.0013 4.256 10.5848 6.253 10.0884 8.158C9.74484 9.485 9.69971 10.976 9.69356 11.962C8.12433 11.635 7.76946 9.347 7.76535 9.323C7.74792 9.204 7.67407 9.1 7.56535 9.044C7.45561 8.988 7.3274 8.984 7.21664 9.037C7.13458 9.076 5.19817 10.036 5.08535 13.867C5.07715 13.995 5.07715 14.122 5.07715 14.249C5.07715 17.971 8.18279 20.999 12.0002 20.999C15.8279 20.989 18.9233 17.965 18.9233 14.249C18.9233 14.062 18.8833 13.538 18.8833 13.538C18.672 10.854 17.39 9.172 16.2597 7.688C15.2125 6.313 14.3079 5.126 14.3079 3.376C14.3079 3.235 14.2269 3.106 14.0997 3.042C14.0433 3.014 13.9828 3 13.9223 3C13.8433 3 13.7654 3.024 13.6997 3.07Z",
          fill: "#F4811F"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M11.6372 13.206C11.4454 13.985 11.4311 14.847 11.4311 15.595C11.4311 15.885 11.19 16.12 10.8916 16.12C9.98492 16.12 9.42594 15.518 9.11415 14.864C8.94697 15.219 8.79517 15.751 8.77363 16.532C8.76953 16.609 8.76953 16.673 8.76953 16.736C8.76953 18.587 10.2188 20.091 12.0003 20.091C13.7818 20.091 15.2311 18.587 15.2311 16.736C15.2311 16.638 15.2239 16.548 15.2177 16.458C15.1049 14.936 14.4608 14.043 13.8372 13.18C13.4013 12.576 12.9562 11.958 12.7265 11.194C12.2126 11.783 11.8065 12.517 11.6372 13.206Z",
          fill: "#FFD753"
        }
      }
    ]
  })(props);
};

export { FireFlashsaleColored };
